import React, { useEffect, useState } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "assets/svgIcons/AccordionExpandMoreIcon";
import { AccordionStyled } from "assets/css/globle";
import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useHookstate } from "@hookstate/core";
import { useDispatch, useSelector } from "react-redux";
import {
  LANGUAGE_GLOBAL_STATE,
  MESSAGE_VDU_GLOBAL_STATE,
} from "../../../../globalStore/globalStore";
import {
  Heading,
  WorkSection,
  BoxWrapper,
  ActionWrapper,
} from "pages/Admin/SiteSettings/SettingStyled";
import { COMMON_SERVICES } from "redux/reduxToolkitServices/_commonServices/commonServices";
import { SITEID_GLOBAL_STATE } from "globalStore/globalStore";
import { useTranslation } from "react-i18next";
import { Button, Tooltip } from "@mui/material";
import { t } from "i18next";

let currencySymbols = [
  { label: "Dollar", value: "$" },
  { label: "Euro", value: "€" },
  { label: "Pounds", value: "£" },
  { label: "Yen", value: "¥" },
  { label: "Tajik", value: "ман" },
  { label: "Bulgarian", value: "лв" },
  { label: "Czech", value: "Kč" },
  { label: "Swedish", value: "kr" },
  { label: "Rupee", value: "₨" },
  { label: "Brazilian", value: "R" },
  { label: "UAE", value: "د.إ" },
  { label: "Malaysian", value: "RM" },
  { label: "Indonesian Rupiah", value: "Rp" },
  { label: "Thai Baht", value: "฿" },
  { label: "Saudi Riyal", value: "ر.س" },
  { label: "Vietnamese Dong", value: "₫" },
];

let thousandsSeparators = [
  { label: "comma", value: "," },
  { label: "FullStop", value: "." },
  { label: "Space", value: " " },
  { label: "Inverted", value: "'" },
];

let decimalSeparators = [
  { label: "comma", value: "," },
  { label: "FullStop", value: "." },
  { label: "Space", value: " " },
  { label: "Inverted", value: "'" },
];

const LocalizationSettings = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { siteId } = useHookstate(SITEID_GLOBAL_STATE);
  const {
    languageState,
    currencyState,
    decimalState,
    thousandState,
    distanceState,
  } = useHookstate(LANGUAGE_GLOBAL_STATE);
  const { setSave } = useHookstate(MESSAGE_VDU_GLOBAL_STATE);
  const { siteSettingsData } =
    useSelector((state) => state?.commonReducers) || [];
  const [currency, setCurrency] = useState("");
  const [tseparator, setTSeparator] = useState("");
  const [dseparator, setDSeparator] = useState("");
  const [distanceUnit, setDistanceUnit] = useState("");
  const [isModified, setIsModified] = useState(true);

  const handleCurrency = (event) => {
    setIsModified(false);
    setCurrency(event.target.value);
    setSave.set(true);
  };
  const handleTSeparator = (event) => {
    setIsModified(false);
    setTSeparator(event.target.value);
    setSave.set(true);
  };
  const handleDSeparator = (event) => {
    setIsModified(false);
    setDSeparator(event.target.value);
    setSave.set(true);
  };
  const handleDistanceUnit = (event) => {
    setIsModified(false);
    setDistanceUnit(event.target.value);
    setSave.set(true);
  };

  useEffect(() => {
    setCurrency(siteSettingsData?.CurrencySymbol);
  }, [siteSettingsData]);

  useEffect(() => {
    setTSeparator(siteSettingsData?.CurrencyThousandsSeparator);
  }, [siteSettingsData]);

  useEffect(() => {
    setDSeparator(siteSettingsData?.CurrencyDecimalSeparator);
  }, [siteSettingsData]);

  useEffect(() => {
    setDistanceUnit(siteSettingsData?.DistanceUnits);
  }, [siteSettingsData]);

  const handleSaveButton = () => {
    const payload = {
      CurrencySymbol: currency,
      ThousandsSeparator: tseparator,
      DecimalSeparator: dseparator,
      DistanceUnits: distanceUnit,
      G2language: "US",
    };
    dispatch(COMMON_SERVICES.putLocalisationServices(payload,siteId.get())).then(() => {
      dispatch(COMMON_SERVICES.getSiteSettingsServices(siteId.get()));
      setIsModified(true);
    });
    setSave.set(false);
  };

  const handleCancel = (e) => {
    setCurrency(siteSettingsData?.CurrencySymbol);
    setTSeparator(siteSettingsData?.CurrencyThousandsSeparator);
    setDSeparator(siteSettingsData?.CurrencyDecimalSeparator);
    setDistanceUnit(siteSettingsData?.DistanceUnits);
    setSave.set(false);
    setIsModified(true);
  };

  let distanceUnitsEnum = [
    { label: t("Yards"), id: 1 },
    { label: t("Meters"), id: 2 },
  ];

  return (
    <AccordionStyled>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Heading>
            <h3>{t("Localization_Settings")}</h3>
          </Heading>
        </AccordionSummary>
        <AccordionDetails>
          <WorkSection>
            <BoxWrapper>
              <div className="all-select-wrapper">
                <div className="select-wrapper">
                  <p className="label">{t("Currency_Symbol")}</p>
                  <Box sx={{ minWidth: 120, maxWidth: 120 }}>
                    <FormControl fullWidth>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={currency}
                        onChange={handleCurrency}
                        IconComponent={KeyboardArrowDownIcon}
                      >
                        {currencySymbols?.map((item, index) => (
                          <MenuItem value={item.value} key={item.value}>
                            {item.value}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                </div>
                <div className="select-wrapper">
                  <p className="label">{t("Thousands_Separator")}</p>
                  <Box sx={{ minWidth: 120, maxWidth: 120 }}>
                    <FormControl fullWidth>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={tseparator}
                        onChange={handleTSeparator}
                      >
                        {thousandsSeparators.map((item) => (
                          <MenuItem value={item.value} key={item.value}>
                            {item.value}&nbsp;
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                </div>
                <div className="select-wrapper">
                  <p className="label">{t("Decimal_Separator")}</p>
                  <Box sx={{ minWidth: 120, maxWidth: 120 }}>
                    <FormControl fullWidth>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={dseparator}
                        onChange={handleDSeparator}
                      >
                        {decimalSeparators.map((item) => (
                          <MenuItem value={item.value} key={item.value}>
                            {item.value}&nbsp;
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                </div>
                <div className="select-wrapper">
                  <p className="label">{t("Distance_units")}</p>
                  <Box sx={{ minWidth: 120, maxWidth: 120 }}>
                    <FormControl fullWidth>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={distanceUnit}
                        onChange={handleDistanceUnit}
                        IconComponent={KeyboardArrowDownIcon}
                      >
                        {distanceUnitsEnum.map((item) => (
                          <MenuItem value={item.id} key={item.label}>
                            {item.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                </div>
              </div>

              <div className="preview">
                <p>{t("Preview")}</p>
                <h6>{`${currency}1${tseparator}234${dseparator}56`}</h6>
              </div>

              <ActionWrapper>
                  <Tooltip title={t("Cancel_localization_settings")} arrow>
                    <span>
                      <Button
                        style={{
                          opacity: setSave.get() === true ? "1" : "0.6",
                          pointerEvents: setSave.get() === true ? "auto" : "none",
                        }}
                        onClick={(e) => handleCancel(e)}
                      >
                        {t("Cancel")}
                      </Button>
                    </span>
                  </Tooltip>
                  <Tooltip title={t("Save_Localization_Settings")} arrow>
                    <span>
                      <Button
                        disabled={isModified}
                        className={!isModified ? "active" : ""}
                        onClick={handleSaveButton}
                      >
                        {t("Save")}
                      </Button>
                    </span>
                  </Tooltip>
                </ActionWrapper>
            </BoxWrapper>         
          </WorkSection>
        </AccordionDetails>
      </Accordion>
    </AccordionStyled>
  );
};

export default LocalizationSettings;
